export const normalizarQuebrasLinha = texto =>
  String(texto ?? '')
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .replace(/\n+$/, '');

export const separarTituloECorpoAtestado = descricao => {
  const normalizado = normalizarQuebrasLinha(descricao);
  const linhas = normalizado.split('\n');
  const titulo = (linhas[0] ?? '').trim();
  const corpo = linhas.slice(1).join('\n');

  return { titulo, corpo };
};
